const React = require('react');
const {default: Button} = require('@material-ui/core/Button');
const Loading = require('../../../Loading');
const Tooltip = require('../../../Tooltip/B');

const BtnDisplay = ({children, onClick, disabled, testId}) => (
  <Button
    type={onClick ? 'button' : 'submit'}
    variant="contained"
    className={`
      (w268|h60|layoutRow|jcC|aiC|f16|fw4|cF|bg5B47FF|r0|bxsh|dn).MuiButton-contained
      (w250)@m.MuiButton-contained
      (cF|bg4B37EF|r0|bxsh).MuiButton-contained:h:not[.disabled]
      (bgA3A7AC|cF|bxsh|crUnset).MuiButton-contained:disabled
    `}
    disabled={disabled}
    onClick={onClick}
    data-testid={testId}
  >
    {children}
  </Button>
)

module.exports = ({children, formCtx, changesCheckDisabled, onClick, disabled, testId}) => {
  const formState = (formCtx || {}).state || {};
  const click = formState.click;
  const isLoading = formState.loading;

  const noChanges = !changesCheckDisabled && !formState.hasChanges;
  const numberOfErrors = Object.keys(formState.errors || {}).length;

  const disabledByFormCtx = noChanges || (click && numberOfErrors);
  //const disabledByFormCtx = false;

  const btn = (
    <BtnDisplay
      disabled={!!(disabled || isLoading || disabledByFormCtx)}
      onClick={onClick}
      testId={testId}
    >
      {isLoading ? <Loading /> : children}
    </BtnDisplay>
  );

  return disabledByFormCtx ? (
    <Tooltip
      className="wmax268 w"
      title={
        noChanges
          ? 'Make some changes to enable button'
          : numberOfErrors
            ? `There is still some (${numberOfErrors}) errors left in form`
            : ''
      }
      disabledCopy
    >
      {btn}
    </Tooltip>
  ) : (
    btn
  )
}
